import { render, staticRenderFns } from "./VTablePagination.vue?vue&type=template&id=80025db2&scoped=true&"
import script from "./VTablePagination.vue?vue&type=script&lang=js&"
export * from "./VTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./VTablePagination.vue?vue&type=style&index=0&id=80025db2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80025db2",
  null
  
)

export default component.exports